import React from 'react';
import { useLocation } from 'react-router-dom';

export type ProductContextBarProps = {
  authenticated?: boolean;
};

type Context = {
  kicker: string;
  title: string;
  summary: string;
};

const contexts: Array<{ test: (path: string) => boolean; value: Context }> = [
  { test: (p) => p === '/', value: { kicker: 'TODAY', title: '오늘', summary: '시장과 내 종목에서 달라진 것을 먼저 봅니다.' } },
  { test: (p) => p.startsWith('/issue'), value: { kicker: 'DISCLOSURES', title: '실시간 공시', summary: '시장에 먼저 들어온 공시 변화를 시간순으로 확인합니다.' } },
  { test: (p) => p.startsWith('/screener'), value: { kicker: 'SCREENER', title: '종목 찾기', summary: '조건을 조합해 지금 확인할 후보를 압축합니다.' } },
  { test: (p) => p.startsWith('/stocks'), value: { kicker: 'DECISION CHART', title: '인텔리전스 차트', summary: '가격·수급·판단 변화의 근거를 한 화면에서 확인합니다.' } },
  { test: (p) => p.startsWith('/feeds'), value: { kicker: 'RESEARCH', title: '정책·이슈', summary: '정책과 이슈를 연결관계와 판단 반영 여부로 추적합니다.' } },
  { test: (p) => p.startsWith('/mypage'), value: { kicker: 'PORTFOLIO', title: '내 투자', summary: '보유 종목, 알림, 계정 상태를 한 흐름으로 관리합니다.' } },
  { test: (p) => p.startsWith('/faq'), value: { kicker: 'GUIDE', title: '이용 안내', summary: 'PolicyIntel의 데이터와 판단 구조를 확인합니다.' } },
];

export default function ProductContextBar({ authenticated = false }: ProductContextBarProps) {
  const { pathname } = useLocation();
  if (!authenticated && (pathname === '/' || pathname === '/terms' || pathname === '/privacy')) return null;
  if (/^\/(login|reset-password|verify-email|confirm-email-change|billing)/.test(pathname)) return null;

  const context = contexts.find((item) => item.test(pathname))?.value;
  if (!context) return null;

  return (
    <div className="pi-context-bar" role="region" aria-label="현재 작업 문맥">
      <div className="pi-context-bar__inner">
        <div className="pi-context-bar__identity">
          <span className="pi-context-bar__kicker">{context.kicker}</span>
          <span className="pi-context-bar__title">{context.title}</span>
        </div>
        <div className="pi-context-bar__summary">{context.summary}</div>
      </div>
    </div>
  );
}
